import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'

import Cookies from 'js-cookie'
import { project } from '@/api/project'
import { department } from '@/api/department'
import { person } from '@/api/person'
import { organization } from '@/api/organization'
import { propertyGroup } from '@/api/property/propertyGroup'

export interface ICommonDataState {
  organizations: any
  departments: any
  projects: any
  persons: any
}

@Module({ dynamic: true, store, name: 'commonData' })
class CommonData extends VuexModule implements ICommonDataState {

  public organizations = []
  public organizationId: any = Cookies.get('organizationId') || ''
  public departments = []
  public projects = []
  public persons = []
  public wyOrganizationId: any = Cookies.get('wyOrganizationId') || ''
  public groups = []

  // 获取所有的组织：
  @Action
  public async getOrganizations(type: string) {
    const organizations: any = await organization('GET', null, null)
    this.SET_ORGANIZTIONS(organizations)
    let xtOrganizations = organizations.filter( (item: any) => {
      return item.roles.indexOf('maintenence') !== -1
    })
    let wyOrganizations = organizations.filter( (item: any) => {
      return item.roles.indexOf('property') !== -1
    })
    if (type === 'maintenence') {
      return xtOrganizations
    } else {
      return wyOrganizations
    }
  }
  // 获取所有组:
  @Action
  public async getGroups() {
    const groups: any = propertyGroup('GET', { wyOrganizationId: this.wyOrganizationId }, null)
    this.SET_GROUPS(groups)
    return groups
  }
  // 获取当前组织所有部门
  @Action
  public async getDepartments() {
    const departmentsdata: any = await department('GET', { organizationId: this.organizationId }, null)
    console.log('departmentsdata is:', departmentsdata)
  }
  // 获取当前组织所有项目
  @Action
  public async getProjects() {
    const projectsData: any = await project('GET', { organizationId: this.organizationId }, null)
    console.log('projectsData is:', projectsData)
  }
  // 获取当前组织所有人员
  @Action
  public async getPersons(personData: {departmentid: number, role: number}) {
    let { departmentid, role } = personData
    const personsData: any = await person('GET', { organizationId: this.organizationId, departmentId: departmentid, position: role }, null)
    // console.log('personsData is:', personsData)
    return personsData
  }

  @Mutation
  public SET_ORGANIZTIONS(organizations: any) {
    this.organizations = organizations
  }
  @Mutation
  public SET_GROUPS(groups: any) {
    this.groups = groups
  }

  @Mutation
  public SET_DEPARMENTS(departments: any) {
    this.departments = departments
  }
  @Mutation
  public SET_PROJECTS(projects: any) {
    this.projects = projects
  }
}
export const CommonDataModule = getModule(CommonData)
